// extracted by mini-css-extract-plugin
export default {"container":"LogoutForce_container__O-muT","message":"LogoutForce_message__Hqakh","wrapper":"LogoutForce_wrapper__zu4ll","info":"LogoutForce_info__8mzoR"};